import React, { useState } from 'react';
import './ContactForm.css';

const ContactForm = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Basic email validation
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      setError('Please enter a valid email address');
      return;
    }
    
    // Form is valid, clear error and set submitted state
    setError('');
    setSubmitted(true);
  };

  return (
    <div className="contact-form-container">
      {submitted ? (
        <div className="success-message">
          <p>Thanks for reaching out! We'll be in touch soon.</p>
        </div>
      ) : (
        <form 
          name="contact" 
          method="POST" 
          data-netlify="true" 
          onSubmit={handleSubmit}
          className="contact-form"
          aria-labelledby="contact-heading"
        >
          <input type="hidden" name="form-name" value="contact" />
          
          <div className="form-group">
            <label htmlFor="email" className="required">
              Email Address
              <span aria-label="required">*</span>
            </label>
            <input
              id="email"
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="name@example.com"
              required
              aria-required="true"
              aria-invalid={error ? 'true' : 'false'}
              aria-describedby={error ? 'email-error' : undefined}
            />
            {error && (
              <div id="email-error" role="alert" className="error-message">
                {error}
              </div>
            )}
          </div>
          
          <button type="submit" className="submit-button" aria-describedby="submit-desc">
            Get in touch
          </button>
          <div id="submit-desc" className="sr-only">
            Submit form to contact Signal Theory
          </div>
        </form>
      )}
    </div>
  );
};

export default ContactForm;
